<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="3"></ucMenu>
					<div class="right_con">
						<div class="goods_main">
							<p class="fb">订单列表</p>
							<div class="select_wrap">
								<el-input class="mr w290" v-model="searchData.order_no" placeholder="请输入订单编号" clearable>
									<p slot="prefix" class="label_title">订单编号</p>
								</el-input>
								<el-select class="mr w290" v-model="searchData.order_status" @change="getList" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">订单状态</p>
									<el-option v-for="item in arrStatus" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select>
								<!-- <el-select class="w290" v-model="searchData.after_sale_status" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">售后状态</p>
									<el-option v-for="item in arrAfterSales" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select> -->
								<!-- <el-select class="w290 mr" v-model="searchData.lack_type" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">缺货状态</p>
									<el-option v-for="item in arrLackType" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select> -->
								<el-input class="w290 " v-model="searchData.express_no" placeholder="请输入物流单号" clearable>
									<p slot="prefix" class="label_title">物流单号</p>
								</el-input>
								<el-input class="w290 mr" v-model="searchData.buyer_name" placeholder="请输入收货人姓名" clearable>
									<p slot="prefix" class="label_title">收货人</p>
								</el-input>
								<el-input class="w290 mr" v-model="searchData.buyer_phone" placeholder="请输入收货人手机号" clearable>
									<p slot="prefix" class="label_title">手机号码</p>
								</el-input>
								<el-date-picker class="w290 "
									v-model="searchData.search_date"
									type="datetimerange"
									align="right"
									unlink-panels
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									value-format="yyyy-MM-dd HH:mm:ss"
									:picker-options="pickerOptions"
									:default-time="['00:00:00', '23:59:59']">
								</el-date-picker>
								<el-button plain size="small" @click="getList()">查询</el-button>
								<el-button plain size="small" @click="resetSearch()">重置</el-button>
							</div>
							<div class="tabs_wrap">
								<p class="tab" :class="!searchData.order_status?'active':''" @click="changeStatus('')">全部</p>
								<p class="tab" :class="searchData.order_status==s.val?'active':''" v-for="(s,i) in arrStatus" :key="i" @click="changeStatus(s.val)">{{s.text}}<el-badge class="mark" :value="s.num" v-if="s.num > 0"/></p>
							</div>
							<div class="totals_btn">
								<p class="totals">共{{page_data.total}}条</p>
								<el-button plain size="small" @click="printDeliver()">打单发货</el-button>
								<el-button plain size="small" @click="showPrintTags(0)" v-if="[1].includes(searchData.order_status)">打印标签</el-button>
								<el-button plain size="small" @click="showAutoDelivery()" v-if="[1,2,11,4].includes(searchData.order_status)||true">打单发货</el-button>
								<!-- <el-button plain size="small">批量发货</el-button> -->
								<el-button plain size="small" @click="orderExport()">批量导出</el-button>
								<el-button plain size="small" @click="multiRemark()">备注</el-button>
								<el-button plain size="small" @click="multiOutOfStock()" v-if="[1,2,11].includes(searchData.order_status)">缺货</el-button>
								<el-button plain size="small" @click="showAfterSalesScan()">退换件扫描</el-button>
							</div>
							<div class="list_title">
								<label class="checkall">
									<el-checkbox v-model="checkAll" @change="bindCheckAll">全选</el-checkbox>
								</label>
								<p class="t1">货品信息</p>
								<p class="t2">售价/数量</p>
								<p class="t3">状态</p>
								<p class="t4">运费</p>
								<p class="t5">买家/收货人</p>
								<!-- <p class="t6">订单状态</p> -->
								<p class="t7">操作</p>
							</div>
							<ul class="order_list">
								<el-checkbox-group v-model="checkList" @change="bindCheckList">
									<li v-for="(item,index) in list" :key="index">
										<div class="order_nums">
											<div class="check_box"><el-checkbox :label="item.id" :key="item.id" :checked="item.checked"></el-checkbox></div>
											<p class="num">订单编号：{{item.order.dd_order_id}}<i class="iconfont icon-fuzhi"  @click="bindCopy(item.order.dd_order_id)"></i></p>
											<!-- <p class="date">下单时间：{{item.order.create_time}}</p> -->
											<p class="date">采购时间：{{item.create_time}}</p>
											<p class="maoli">买家备注：{{item.order.buyer_words}}</p>
										</div>
										<div class="order_info">
											<div class="order_product">
												<div class="product_item"  v-for="(product,pindex) in item.supplier_order_product">
													<div class="goods_info">
														<div class="img_wrap">
															<div class="img_box">
																<img class="coverimg" :src="product.product_pic" />
															</div>
															<el-link v-if="product.is_exchange !=1 && product.is_cancel==0 && ['已支付','备货中'].includes(item.order.main_status_text)" style="margin-top: 10px;" icon="el-icon-s-release" type="danger" @click="setOutOfStock(product.id)">缺货</el-link>
															<span style="margin: 5px auto;" class="el-checkbox__input " :class="supplier_order_product_ids.includes(product.id)?'is-checked':''"><span class="el-checkbox__inner" @click="selectSupplierOrderId(product.id)"></span></span>
														</div>

														<div class="con_box">
															<p class="title">{{product.product_name}}</p>
															<p class="t1">{{product.spec_value}}</p>
															<p class="t2">商家：{{item.order.business.nickname}}</p>
															<p class="t2"><span class="remark">备注：<span :title="product.supplier_remark">{{product.supplier_remark}}</span> <i class="iconfont el-icon-edit" @click="showRemark(product)"></i></span></p>
														</div>
													</div>
													<div class="goods_num">
														<p class="t1">{{product.item_amount}}</p>
														<p class="t2">x{{product.item_num}}</p>
													</div>
													<div class="goods_sales">
														<!-- <p class="black">{{product.order_status_text}}</p> -->
														<p class="black" v-if="product.is_cancel==1">取消采购</p>
														<p class="black" v-if="product.is_cancel==0">已采购</p>
														<!-- <p class="warning" v-if="product.order_after_sales">{{product.order_after_sales.aftersale_status_text}}</p> -->
														<p class="warning" v-if="product.is_out_of_stock">缺货</p>
														<p class="warning" v-if="product.is_exchange">换货订单</p>
													</div>
													<div class="goods_operate">
														
														<div v-if="item.is_make_tags==1&&pindex==0" style="margin-bottom: 10px;">
															<p v-if="item.deliver_status==1&&product.is_cancel!=1&& item.deliver_status==1" class="red" @click="showPrintDelivery(item)">打单发货</p>
															<p v-if="product.is_cancel!=1 && item.deliver_status==2" class="red" @click="showOrderPrinter(item.id)">补打面单</p>
														</div>
														
														<p v-if="product.is_cancel!=1&&item.deliver_status==1" class="red" @click="showPrintTags(product.id)">打印标签</p>	
														<div v-if="product.is_cancel!=1 &&product.order_after_sales">
															<p class="red" @click="showAfterSaleInfo(product)">{{product.order_after_sales.aftersale_status_text}}
																<span v-if="product.order_after_sales.refund_type==2&&product.order_after_sales.refund_status==3&&product.order_after_sales.supplier_pass==0">,待确认退款</span>
															</p>
															<!-- <p class="red" @click="showAfterSaleInfo(product)" v-if="product.is_cancel!=1 &&(product.order_after_sales.aftersale_status==6||product.order_after_sales.aftersale_status==11)">系统将在{{product.order_after_sales.status_deadline}}后自动同意</p> -->
														</div>
													</div>
												</div>
											</div>
											<div class="goods_pay">
												<p class="t1">￥{{item.freight_price}}</p>
											</div>
											<div class="goods_buyer">
												<p>{{item.order_address.mask_name}}</p>
												<p>{{item.order_address.mask_phone}}</p>
												<p>{{item.order_address.province}}{{item.order_address.city}}{{item.order_address.town}}{{item.order_address.mask_detail}}
												<!-- <el-tooltip class="item" effect="dark" content="点击查看" placement="top">
													<i class="iconfont el-icon-view" @click="showAddressInfo(item.order_id)"></i>
												</el-tooltip> -->
												<p v-if="item.deliver_status==2"><a :href="'/uc_order_detail?order_id='+item.order_id" class="details text-red">查看物流</a></p>
												</p>
											</div>
											<!-- <div class="goods_status">
												<p>{{item.order.order_status_text}}</p>
											</div> -->
											<div class="goods_status">
												<!-- <p v-if="item.deliver_status==1&&(item.order.order_status==2||item.order.order_status==101)"><a href="javascript:;" @click="showDelivery(item.order_id)" class="details">发货</a></p> -->
												
												<!-- <p><a v-if="item.deliver_status==2" class="details" @click="logisticsDetail(item)">查看物流</a></p> -->
											</div>
										</div>
									</li>
								</el-checkbox-group>
								<li class="nodata" v-if="page_data.total == 0">暂无数据</li>
							</ul>
							<div class="turn_page">
								<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" />
							</div>
						</div>
					</div>
				</div>
				<!-- 收货地址信息弹窗 -->
				<orderAddress @close="dialog.addressDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.addressDialog" :order_id.sync="order_id"></orderAddress>
				<!-- 发货/信息弹窗 -->
				<el-dialog title="订单发货" :visible.sync="dialog.deliverDialog" width="20%" center >
					<orderDeliver @close="dialog.deliverDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.deliverDialog" :order_id.sync="order_id"></orderDeliver>
				</el-dialog>
				<!-- 售后详情弹窗 -->
				<el-dialog title="售后详情" :visible.sync="dialog.aftersaleDialog" width="70%" center >
					<orderAfterSales @close="dialog.aftersaleDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.aftersaleDialog" :info.sync="supplier_order_product"></orderAfterSales>
				</el-dialog>
				<!-- 备注弹窗 -->
				<supplierRemark @close="dialog.remarkDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.remarkDialog" :ids.sync="order_product_ids" :remark.sync="remark"></supplierRemark>
				<el-drawer
				  title="物流轨迹"
				  :visible.sync="dialog.trackDialog"
				  direction="rtl">
				  <trackDetail @close="dialog.trackDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.trackDialog" :order_id.sync="order_id"></trackDetail>
				</el-drawer>

				<!-- 缺货弹窗 -->
				<outOfStock @close="dialog.outOfStockDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.outOfStockDialog" :ids.sync="order_product_ids"></outOfStock>
				<!-- 退换件扫描 -->
				<el-dialog title="退换件扫描" :visible.sync="dialog.aftersaleScanDialog" width="1100px" center :close-on-click-modal="false">
					<afterSalesScan @close="dialog.aftersaleScanDialog = false" @complete="refresh()" :show.sync="dialog.aftersaleScanDialog"></afterSalesScan>
				</el-dialog>

			</div>
		</div>
		<!-- 打印标签弹窗 -->
		<el-dialog title="打印标签" :visible.sync="dialog.tagsDialog" width="400px" center >
			<orderTags @close="dialog.tagsDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.tagsDialog" :order_id.sync="sop_ids"></orderTags>
		</el-dialog>
		<!-- 自动打单发货弹窗 -->
		<el-dialog title="自动打单发货" :visible.sync="dialog.autoDeliverDialog" width="800px" center :close-on-click-modal="false">
			<autoPrintDeliver @close="dialog.autoDeliverDialog = false,getList()" @success="printDeliverSuccess" :isLoading.sync="isLoading" :show.sync="dialog.autoDeliverDialog"></autoPrintDeliver>
		</el-dialog>
		<!-- 打印弹窗 -->
		<el-dialog title="打印订单" :visible.sync="dialog.printDialog" width="400px" center >
			<orderPrinter @close="dialog.printDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.printDialog" :ids.sync="sop_ids"></orderPrinter>
		</el-dialog>
		<!-- 单订单打单发货 -->
		<el-dialog title="打单发货" :visible.sync="dialog.orderPrinterDeliverDialog" width="800px" center >
			<orderPrintDeliver @close="dialog.orderPrinterDeliverDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.orderPrinterDeliverDialog" :supplier_order.sync="supplier_order"></orderPrintDeliver>
		</el-dialog>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import orderAddress from '../../components/orderAddress/orderAddress';
import orderDeliver from '../../components/orderDeliver/orderDeliver';
import orderAfterSales from '../../components/orderAfterSales/orderAfterSales';
import afterSalesScan from '../../components/afterSalesScan/afterSalesScan';
import trackDetail from '../../components/trackDetail/trackDetail';
import supplierRemark from '../../components/supplierRemark/supplierRemark';
import outOfStock from '../../components/outOfStock/outOfStock';
import Pagination from '../../components/pagination/pagination';

import orderTags from '../../components/orderTags/orderTags';
import autoPrintDeliver from '../../components/autoPrintDeliver/autoPrintDeliver';
import orderPrinter from '../../components/orderPrinter/orderPrinter';
import orderPrintDeliver from '../../components/orderPrintDeliver/orderPrintDeliver';
export default {
	name: "ucenterOrders",
	data() {
		return {
			order_id: 0,
			options: [],
			arrStatus:[],
			arrAfterSales:[],
			arrLackType: [],
			checkAll: false,
			checkList: [],
			isLoading:false,
			list:[],
			remark: '',
			order_product_ids: [],
			supplier_order_product_ids: [],
			sop_ids: [],
			supplier_order: null,
			page_data: {
				limit: 10,
				page: 1,
				total:0,
			},
			searchData: {},
			dialog: {
				addressDialog:false,
				deliverDialog:false,
				aftersaleDialog:false,
				trackDialog:false,
				remarkDialog:false,
				outOfStockDialog:false,
				aftersaleScanDialog:false,
				
				tagsDialog: false,
				autoDeliverDialog: false,
				printDialog:false,
				orderPrinterDeliverDialog: false,
			},

			is_refuse:false,
			textarea:"",
			supplier_order_product: null,
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	components:{
		myHead,myFoot,ucMenu,orderAddress,orderDeliver,orderAfterSales,afterSalesScan,trackDetail,Pagination,supplierRemark,outOfStock,orderTags,autoPrintDeliver,orderPrinter,orderPrintDeliver
	},
	created() {
		this.getList()

	},
	methods: {
		...mapActions({
			getSupplierOrderList:"ucenter/getSupplierOrderList",
			getSupplierOrderAddressInfo:"ucenter/getSupplierOrderAddressInfo",
			getSupplierOrderFilterData:"ucenter/getSupplierOrderFilterData",
			getSupplierOrderDetail:"ucenter/getSupplierOrderDetail",
			opSupplierOrderDeliver:"ucenter/opSupplierOrderDeliver",
			opSupplierOrderExport:"ucenter/opSupplierOrderExport",
			opOrderProductOutOfStock:"ucenter/opOrderProductOutOfStock",
		}),
		initFilterData(){
			this.getSupplierOrderFilterData({data:{},success:(res)=>{
				if(res.code===200){
					// console.log('get goods filter data',res)
					this.arrStatus = res.data.arr_status
					this.arrAfterSales = res.data.arr_after_sales
					this.arrLackType = res.data.arr_lack_type
				}
			}})
		},
		//重置搜索
		resetSearch(){
			this.searchData = {}
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		//刷新列表
		refresh(){
			this.page_data.page = 1
			this.checkAll = false
			this.checkList = []
			this.supplier_order_product_ids = []
			this.getList()
		},
		changeStatus(val){
			this.searchData.order_status = val
			this.refresh()
		},
		getList(showLoading = true){
			if(showLoading) this.isLoading = true
			let param = {limit:this.page_data.limit,page:this.page_data.page}
			Object.assign(param, this.searchData)
			if(this.page_data.page == 1){
				this.initFilterData()
			}
			// console.log(param)
			this.getSupplierOrderList({data:param,success:(res)=>{
				if(res.code===200){
					// console.log('get order list',res)
					this.list = res.data.data
					this.page_data.total = res.data.total
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.isLoading = false
			}})
		},
		setOutOfStock(id){
			console.log(id)
			this.$confirm('设置缺货将自动取消采购并退款给商家, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = {ids:id}
				this.opOrderProductOutOfStock({data:param,success:(res)=>{
					if(res.code===200){
						this.$message({message: res.msg,type: 'success'})
						this.getList()
					} else {
						this.$message({message: res.msg,type: 'error',});
					}
					this.isLoading = false
				}})
			}).catch((res) => {
			})
		},
		printDeliver(){
			this.$router.replace('./uc_order_deliver?menuId=6')
		},
		//订单导出
		orderExport(){
			if(this.isLoading) return
			this.isLoading = true
			let param = {limit:this.page_data.limit,page:this.page_data.page,is_export:1,ids:this.checkList}
			Object.assign(param, this.searchData)
			this.getSupplierOrderList({data:param,success:(res)=>{
				if(res.code===200){
					window.open(res.data)
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.isLoading = false
			}})
		},
		showAddressInfo(id){
			this.order_id = id
			this.dialog.addressDialog = true
		},
		showDelivery(id){
			this.order_id = id
			this.dialog.deliverDialog = true
		},
		showAfterSaleInfo(supplier_order_product){
			this.supplier_order_product = supplier_order_product
			this.dialog.aftersaleDialog = true
		},
		//退货件扫码弹窗
		showAfterSalesScan(){
			this.dialog.aftersaleScanDialog = true
		},
		multiRemark(){
			let ids = this.checkList
			if(ids.length == 0){
				this.$message({
					message: '请选择订单',
					type: 'warning'
				});
				return
			}
			let list = this.list
			let order_product_ids = []
			for (var i in list){
				if(ids.findIndex(val => val == list[i].id) !== -1){
					var supplier_order_product = list[i].supplier_order_product
					for(var j in supplier_order_product){
						order_product_ids.push(supplier_order_product[j].order_product_id);
					}
				}

			}


			this.remark = ''
			this.order_product_ids = order_product_ids
			this.dialog.remarkDialog = true
		},
		multiOutOfStock(){
			let ids = this.checkList
			if(ids.length == 0){
				this.$message({
					message: '请选择订单',
					type: 'warning'
				});
				return
			}
			let list = this.list
			let order_product_ids = []
			let supplier_order_product_ids = []
			for (var i in list){
				if(ids.findIndex(val => val == list[i].id) !== -1){
					var supplier_order_product = list[i].supplier_order_product
					for(var j in supplier_order_product){
						order_product_ids.push(supplier_order_product[j].order_product_id);
						supplier_order_product_ids.push(supplier_order_product[j].id);
					}
				}

			}
			console.log(supplier_order_product_ids)
			this.$confirm('设置缺货将自动取消采购并退款给商家, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = {ids:supplier_order_product_ids.join(',')}
				this.opOrderProductOutOfStock({data:param,success:(res)=>{
					if(res.code===200){
						this.$message({message: res.msg,type: 'success'})
						this.getList()
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.getList()
					}
					this.isLoading = false
				}})
			}).catch((res) => {
			})

			//以下是老版本的缺货
			// this.remark = ''
			// this.order_product_ids = order_product_ids
			// this.dialog.outOfStockDialog = true
		},
		showRemark(supplier_order_product){
			this.remark= supplier_order_product.supplier_remark
			this.order_product_ids = [supplier_order_product.order_product_id]
			this.dialog.remarkDialog = true
		},
		bindCopy(text){
			var str = ''
			var input = document.createElement("input"); // 创建input对象
			input.value = text; // 设置复制内容
			document.body.appendChild(input); // 添加临时实例
			input.select(); // 选择实例内容
			document.execCommand("Copy"); // 执行复制
			document.body.removeChild(input); // 删除临时实例
			this.$message({
				message: '复制成功',
				type: 'success'
			});

		},
		//全选
		bindCheckAll(){
			let checkAll = this.checkAll
			let list = this.list
			let checkList = []
			if(checkAll){
				for(var i in list){
					if(checkAll){
						checkList.push(list[i].id)
					}
				}
			}
			this.checkList = checkList
		},
		//单项选
		bindCheckList(){
			let checkList = this.checkList
			console.log(checkList)
			if(checkList.length == this.list.length){
				this.checkAll = true
			}else{
				this.checkAll = false
			}
		},
		//查看物流
		logisticsDetail(item){
			console.log(item)
			this.order_id = item.order_id
			this.dialog.trackDialog = true
		},
		selectSupplierOrderId(supplier_order_product_id){
			let index = this.supplier_order_product_ids.findIndex(val => val == supplier_order_product_id)
			if(index === -1){
				this.supplier_order_product_ids.push(supplier_order_product_id)
			}else{
				this.supplier_order_product_ids.splice(index,1)
			}
		},
		showPrintTags(id){
			if(id!=0){
				this.sop_ids = [id]
			}else{
				this.sop_ids = this.supplier_order_product_ids
			}
			this.dialog.tagsDialog = true
		},
		showAutoDelivery(){
			this.dialog.autoDeliverDialog = true
		},
		//批量打单成功回调
		printDeliverSuccess(){
			this.getList()
		},
		showOrderPrinter(id){
			this.sop_ids = [id]
			this.dialog.printDialog = true
		},
		showPrintDelivery(supplier_order){
			this.supplier_order = supplier_order
			this.dialog.orderPrinterDeliverDialog = true
		}
	}
}
</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 30px 0 40px;display: flex;justify-content: space-between;flex: 1;}
.right_con{width: 980px;background: #fff;}
.goods_main{padding: 36px 40px 46px;min-height: 70vh;}
.select_wrap{margin-top: 24px;display: flex;flex-wrap: wrap;}
.select_wrap .mr{margin-right: 15px;}
.select_wrap .w290{width: 290px;margin-top: 14px;}
.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;padding-left: 6px;}
.select_wrap .label_title .icon-shuoming{font-size: 12px;color: #999;margin-left: 2px;}
.tabs_wrap{width: 100%;height: 60px;border-bottom: 1px solid #eee;display: flex;white-space: nowrap;}
.tabs_wrap .tab{height: 100%;padding: 30px 16px 0;position: relative;line-height: 1;cursor: pointer;font-size: 14px;color: #666;box-sizing: border-box;display: flex;justify-content: center;align-items: center;}
.tabs_wrap .tab.active{font-weight: bold;color: var(--red);}
.tabs_wrap .tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: 0;z-index: 2;}
.tabs_wrap .tab .iconfont{font-size: 14px;color: #1966ff;}
.tabs_wrap .tab .mark {position: absolute;vertical-align: middle;display: inline-block;right: 0px;bottom: 10px;}

.totals_btn{margin-top: 14px;display: flex;align-items: center;}
.totals_btn .totals{font-size: 12px;color: #333;padding-right: 16px;margin-right: 16px;line-height: 1;border-right: 1px solid #ccc;}

.list_title{width: 100%;height: 50px;background: #f9f9f9;margin-top: 10px;display: flex;align-items: center;font-size: 12px;color: #666;line-height: 1;}
.list_title .checkall{margin-left: 20px;}
.list_title .t1{margin-left: 10px;width: 260px;}
.list_title .t2{margin: 0 20px;width: 60px;text-align: right;}
.list_title .t3{margin: 0 10px;width: 120px;text-align: left;}
.list_title .t4{margin-left: 20px;width: 60px;text-align: right;}
.list_title .t5{margin: 0 20px;width: 150px;text-align: left;}
.list_title .t6{margin: 0 20px 0 0;flex: 1;text-align: left;}
.list_title .t7{margin: 0 20px 0 0;flex: 1;text-align: right;}
.order_list li{margin-top: 10px;font-size: 12px;}
.order_list li .order_nums{width: 100%;height: 40px;background: #fff6f7;display: flex;align-items: center;}
.order_list li .order_nums .check_box{margin-left: 20px;}
.order_list li .order_nums .num{display: flex;align-items: center;margin-left: 12px;color: #666666;}
.order_list li .order_nums .num .iconfont{cursor: pointer;font-size: 14px;color: #666;margin-left: 8px;}
.order_list li .order_nums .date{margin-left: 26px;color: #666666;}
.order_list li .order_nums .maoli{margin-left: 30px;color: #666666;}
.order_list li .order_info{padding: 20px 0;border-bottom: 1px solid #eee;display: flex;align-items: flex-start;line-height: 1;position: relative;}
.order_list li .order_info .order_product{display: felx;flex-direction: column;}
.order_list li .order_info .order_product .product_item{display: flex;padding-bottom: 20px;}
.order_list li .order_info .order_product .product_item:last-child{padding-bottom: 0;}
.order_list li .order_info .goods_info{width: 320px;display: flex;margin-left: 20px;}
.order_list li .order_info .goods_info .img_box{width: 48px;height: 48px;background-color: #eeeeee;border-radius: 6px;overflow: hidden;}
.order_list li .order_info .goods_info .con_box{flex: 1;width: 0;margin-left: 10px;}
.order_list li .order_info .goods_info .con_box .title{line-height: 16px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
.order_list li .order_info .goods_info .con_box .t1{color: #999999;margin-top: 12px;}
.order_list li .order_info .goods_info .con_box .t2{color: #999999;margin-top: 8px;}
.order_list li .order_info .goods_info .con_box .t2 .remark{display: inline-flex;align-items: center;width: 100%;position: relative;white-space: nowrap;color: #f0b92c;}
.order_list li .order_info .goods_info .con_box .t2 .remark span{white-space: nowrap;text-overflow: ellipsis;overflow: hidden;display: inline-block;max-width: 80%;}
.order_list li .order_info .goods_info .con_box .t2 .remark i{margin-left: 5px;cursor: pointer;}
.order_list li .order_info .goods_info .con_box .guanlian{color: #1966ff;margin-top: 8px;cursor: pointer;}
.order_list li .order_info .goods_info .con_box .guanlian:hover{text-decoration: underline;}
.order_list li .order_info .goods_num{margin: 0 20px;width: 60px;text-align: right;}
.order_list li .order_info .goods_num .t1{color: #333333;}
.order_list li .order_info .goods_num .t2{color: #999999;margin-top: 10px;}
.order_list li .order_info .goods_sales{margin: 0 10px;width: 120px;text-align: left;}
.order_list li .order_info .goods_sales p{color: #333;margin-bottom: 5px;}
.order_list li .order_info .goods_sales p.red{color: var(--red);cursor: pointer;}
.order_list li .order_info .goods_sales p.warning{color: #f0b92c;}

.order_list li .order_info .goods_operate {position: absolute;right: 0;width: 80px;padding-right: 10px;}
.order_list li .order_info .goods_operate p{color: #333;margin-bottom: 5px;text-align: right;line-height: 18px;}
.order_list li .order_info .goods_operate p.red{color: var(--red);cursor: pointer;}
.order_list li .order_info .goods_operate p.warning{color: #f0b92c;text-align: right;}
.order_list li .order_info .goods_pay{margin-left: 20px;width: 60px;text-align: right;}
.order_list li .order_info .goods_pay .t1{color: #333333;}
.order_list li .order_info .goods_pay .t2{color: #333333;margin-top: 10px;}
.order_list li .order_info .goods_pay .t3{color: #666666;margin-top: 20px;}
.order_list li .order_info .goods_pay .t4{color: #666666;margin-top: 10px;}
.order_list li .order_info .goods_buyer{margin: 0 20px;width: 150px;text-align: left;}
.order_list li .order_info .goods_buyer>p{line-height: 18px;color: #666;}
.order_list li .order_info .goods_buyer>p .iconfont{cursor: pointer;font-size: 12px;color: #666;margin-left: 8px;}
.order_list li .order_info .goods_status{margin: 0 20px 0 0;flex: 1;text-align: left;}
.order_list li .order_info .goods_status:last-child{text-align: right;}
.order_list li .order_info .goods_status>p{margin-bottom: 10px;}
.order_list li .order_info .goods_status .details{color: #f0413e;cursor: pointer;}
.order_list li .order_info .goods_status .details:hover{text-decoration: underline;}
.order_list li .order_info .goods_status p>a{color: #f0413e;cursor: pointer;}
.order_list li .order_info .goods_status p>a:hover{text-decoration: underline;}
.order_list li .order_remarks{padding: 16px 0;border-bottom: 1px solid #eee;display: flex;align-items: flex-start;}
.order_list li .order_remarks .txt{font-size: 12px;color: #999999;line-height: 18px;width: 78px;box-sizing: border-box;padding-left: 10px;}
.order_list li .order_remarks .remarks{flex: 1;width: 0;font-size: 12px;color: #333;line-height: 18px;}
.turn_page{display: flex;justify-content: flex-end;margin-top: 30px;}

.refuse_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.refuse_mask.active{visibility: visible;opacity: 1;}
.refuse_mask .refuse_main{width: 400px;height: 310px;box-sizing: border-box;padding: 36px 0 40px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;}
.refuse_mask.active .refuse_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.refuse_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.refuse_main .title{margin: 0 32px;font-size: 20px;line-height: 1;}
.refuse_main .ta_wrap{margin: 25px 32px 0;}
.refuse_main .btn_wrap{margin: 30px 32px 0;display: flex;justify-content: space-between;}
.refuse_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.refuse_main .btn_wrap .btn:nth-child(1){border: 1px solid #dddddd;color: #333;}
.refuse_main .btn_wrap .btn:nth-child(2){background: #f0413e;color: #fff;}
/deep/.order_list li .check_box .el-checkbox__label{display: none !important;}
</style>
<style>
.select_wrap .el-button{margin-top: 14px;}
.el-input--prefix .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected{color: var(--red);}
.el-input--prefix .el-input__inner:focus ,.el-textarea__inner:focus{border-color: var(--red);}

.el-button{color: #333;border-color: #ddd;}
.el-button--small{padding: 7px 15px;}
.el-checkbox{color: #666;display: flex;align-items: center;}
.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
.el-checkbox__input{display: flex;}
.el-checkbox__label{font-size: 12px;line-height: 1;}
.el-checkbox__inner::after{height: 9px;left: 5px;}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus{border-color: var(--red);}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}
.el-input__icon{line-height:unset;}


.el-date-editor .el-range-separator{line-height: 26px;}
.el-date-editor{width:290px !important;height: 34px !important;line-height: 34px !important;font-size: 12px !important;margin-top: 14px;}
.el-range-editor.is-active, .el-range-editor.is-active:hover{border-color: var(--red);}
.el-date-table td.end-date span, .el-date-table td.start-date span{background-color: var(--red);}
.el-date-table td.today span{color: var(--red);}
.el-picker-panel__icon-btn:hover,.el-date-table td span:hover,.el-date-table td div:hover,.el-date-table td.available:hover,.el-picker-panel__shortcut:hover{color: var(--red);}
.el-date-editor .el-range__icon{line-height: 27px;}
.text-red{color: var(--red);}
</style>
